/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Pair } from './pair';

export interface Rfq {
  id?: number;
  accountId?: number;
  account?: Account;
  pairId?: number;
  pair?: Pair;
  side?: Rfq.SideEnum;
  rfqType?: Rfq.RfqTypeEnum;
  price?: number;
  units?: number;
  total?: number;
  requestTime?: string;
  expireTime?: string;
  orderId?: number;
}
export namespace Rfq {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const RfqTypeEnum = {
    FiveSeconds: 'FIVE_SECONDS',
    ThirtySeconds: 'THIRTY_SECONDS',
    OneSecond: 'ONE_SECOND',
    EightSeconds: 'EIGHT_SECONDS',
  } as const;
  export type RfqTypeEnum = (typeof RfqTypeEnum)[keyof typeof RfqTypeEnum];
}
